import Collection from "lib/collection";
import ShippingChargeModel from "../models/payments/shipping-charge";

export default Collection.extend({
    model: ShippingChargeModel,
});
